export enum AddressType {
  FROM_CLIENT = 'from_client',
  OTHER = 'other',
  NOT_BUILT_YET = 'not_build',
}
